import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import NewMassMessage2 from './NewMassMessage2';
import NewMassMessageLegacy from '../../../../components/Routes/Messaging/MassMessaging/NewMassMessage';

const NewMassMessageGate = props => {
  const flags = useFlags();
  if (flags.events) return <NewMassMessage2 {...props} />;
  return <NewMassMessageLegacy {...props} />;
};

export default NewMassMessageGate;
